<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png"
        alt="" />
</ng-container>

<mat-card class="simple-card mx-auto">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between" *ngIf="showHeader">
                <h1>Reporte Multas</h1>
                <button
                    mat-flat-button
                    class="custom-button-primary no-print"
                    (click)="generatePDF()"
                    [disabled]="isPDFLoading">
                    <mat-icon aria-hidden="false" aria-label="Icono de descarga" fontIcon="get_app" class="icon-download"></mat-icon>
                    Descargar Resultado
                    <mat-icon *ngIf="isPDFLoading" iconPositionEnd>
                        <mat-spinner class="custom-white-spinner" diameter="15"></mat-spinner>
                    </mat-icon>
                </button>
            </div>

            <div class="col-12 my-3" *ngIf="showHeader">
                <mat-chip-set aria-label="Rut principal">
                    <mat-chip class="chip-rut"><strong>RUT:</strong> {{content.DatosBasicosSolicitud.Rut | number:
                        '1.0-0'}}-{{content.DatosBasicosSolicitud.DV | uppercase}}</mat-chip>
                </mat-chip-set>
            </div>

            <div class="col-12">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Empleador</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>

                        <div class="p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-500">Rut:</div>
                                <div>{{ rut ? (rut | rutFormat) : '' }}</div>

                                <div class="font-weight-500">Razón social:</div>
                                <div>{{ razonSocial || '' }}</div>
                            </div>
                        </div>

                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-12 mt-5 mb-3">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Totales</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <div class="two-equal-columns-grid p-5">
                            <div>
                                <div class="font-weight-500 mb-3">Total multas ejecutoriadas</div>
                                <div></div>

                                <div class="col-12 border mx-auto px-0">
                                    <div class="table-responsive w-100">
                                        <table mat-table [dataSource]="totalMultasEjecutoriadasDataSource">

                                            <ng-container matColumnDef="unidad">
                                                <th mat-header-cell *matHeaderCellDef>Unidad</th>
                                                <td mat-cell *matCellDef="let element"> {{ element.unidad }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="pagadas">
                                                <th mat-header-cell *matHeaderCellDef>Pagadas</th>
                                                <td mat-cell *matCellDef="let element">{{ formatMonto(element.pagadas.total, element.pagadas.cantidad) }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="cobranza">
                                                <th mat-header-cell *matHeaderCellDef>En trámite de cobranza</th>
                                                <td mat-cell *matCellDef="let element">{{ formatMonto(element.cobranza.total, element.cobranza.cantidad) }}</td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="totalMultasDisplayedColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: totalMultasDisplayedColumns;"></tr>

                                            <tr class="mat-mdc-row" *matNoDataRow>
                                                <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="multasDisplayedColumns.length">
                                                    No hay datos disponibles
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="font-weight-500 mb-3">Total multas ley 21.227</div>
                                <div></div>

                                <div class="col-12 border mx-auto px-0">
                                    <div class="table-responsive w-100">
                                        <table mat-table [dataSource]="totalMultasLey21227DataSource">
                                            <ng-container matColumnDef="unidad">
                                                <th mat-header-cell *matHeaderCellDef>Unidad</th>
                                                <td mat-cell *matCellDef="let element"> {{ element.unidad }} </td>
                                            </ng-container>

                                            <ng-container matColumnDef="pagadas">
                                                <th mat-header-cell *matHeaderCellDef>Pagadas</th>
                                                <td mat-cell *matCellDef="let element">{{ formatMonto(element.pagadas.total, element.pagadas.cantidad) }}</td>
                                            </ng-container>

                                            <ng-container matColumnDef="cobranza">
                                                <th mat-header-cell *matHeaderCellDef>En trámite de cobranza</th>
                                                <td mat-cell *matCellDef="let element">{{ formatMonto(element.cobranza.total, element.cobranza.cantidad) }}</td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="totalMultasDisplayedColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: totalMultasDisplayedColumns;"></tr>

                                            <tr class="mat-mdc-row" *matNoDataRow>
                                                <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="multasDisplayedColumns.length">
                                                    No hay datos disponibles
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-12 mt-5 mb-3">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Multas</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>

                        <div class="row p-5">
                            <div class="col-12 border mx-auto px-0">

                                <div class="table-responsive">
                                    <table mat-table [dataSource]="multasDataSource" class="custom-print-table">
                                        <ng-container matColumnDef="procedencia">
                                            <th mat-header-cell *matHeaderCellDef>Procedencia</th>
                                            <td mat-cell *matCellDef="let element">{{ element.procedencia }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="multa">
                                            <th mat-header-cell *matHeaderCellDef>Multa</th>
                                            <td mat-cell *matCellDef="let element">{{ element.multa }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="tipo">
                                            <th mat-header-cell *matHeaderCellDef>Tipo</th>
                                            <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="estado">
                                            <th mat-header-cell *matHeaderCellDef>Estado</th>
                                            <td mat-cell *matCellDef="let element">
                                                <mat-chip appereance="outline" color="primary"
                                                    class="{{ getStatusClass(element.estado) }} status-chip">
                                                    {{ getStatusLabel(element.estado) }}
                                                </mat-chip>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="fecha">
                                            <th mat-header-cell *matHeaderCellDef>Fecha</th>
                                            <td mat-cell *matCellDef="let element">{{ element.fecha }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="monto">
                                            <th mat-header-cell *matHeaderCellDef>Monto</th>
                                            <td mat-cell *matCellDef="let element">{{ element.monto }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="enunciado">
                                            <th mat-header-cell *matHeaderCellDef>Enunciado</th>
                                            <td mat-cell *matCellDef="let element">{{ element.enunciado }}</td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="multasDisplayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: multasDisplayedColumns;"></tr>

                                        <tr class="mat-mdc-row" *matNoDataRow>
                                            <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="multasDisplayedColumns.length">
                                                No hay datos disponibles
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

        </div>
    </mat-card-content>
</mat-card>